import React, {useContext, useEffect} from 'react';
import {ContextOperacion, ContextOperacionType} from "../../RefactorLayout";
import {useOperacionCorporateLending} from "./hooks/useOperacionCorporateLending";
import {EntityWithIdFields, QueryStatus} from "../../../../types";
import {useLoader} from "../../../../hooks/useLoader";
import {Alert, Grid} from "@mui/material";
import {FormOperacionCorporateLending, schemaFormOperacionCorporateLending} from "./types/types";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import SeccionCorporateLendingDatosOperacion from "./components/SeccionCorporateLendingDatosOperacion";
import SeccionCorporateLendingDetalle from "./components/SeccionCorporateLendingDetalle";
import {SeccionFirmas} from "../../components/SeccionFirmas";
import {OperacionCorporateLendingViewDTO} from "./types/dto";
import {SistemaTipo} from "../../../../types/enum/enum";
import CardActions from "../../components/CardActions";

interface SistemaCorporateLendingContentProps {
  operacion: OperacionCorporateLendingViewDTO
}

const SistemaCorporateLendingContent = ({operacion}: SistemaCorporateLendingContentProps) => {
  const {setSavePromise, permisoTipo} = useContext<ContextOperacionType>(ContextOperacion);

  const formMethods = useForm<FormOperacionCorporateLending>({
    resolver: zodResolver(schemaFormOperacionCorporateLending),
    values: {...operacion}
  });

  const {showLoader, hideLoader} = useLoader();


  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <CardActions
            title={'Datos Operación'}
            colapsable
          >
            <SeccionCorporateLendingDatosOperacion
              formMethods={formMethods}
              readOnly={!operacion.permiteEditarOperacion}
              operacion={operacion}
              codSistemaPrincipal={operacion.codPais}
            />
          </CardActions>
        </Grid>

        <Grid item xs={12}>
          <CardActions
            title={'Detalle'}
            colapsable
          >
            <SeccionCorporateLendingDetalle
              codPais={operacion.codPais}
              operacionId={operacion.id}
            />
          </CardActions>
        </Grid>

        <Grid item xs={12}>
          <SeccionFirmas
            codSistema={SistemaTipo.CorporateLending}
            idOperacion={operacion[EntityWithIdFields.Id]}
          />
        </Grid>
      </Grid>
    </>
  );
}

function SistemaCorporateLending() {
  const {idOperacion} = useContext<ContextOperacionType>(ContextOperacion);

  const {status, operacion} = useOperacionCorporateLending(idOperacion);

  const {showLoader, hideLoader} = useLoader();

  useEffect(() => {
    if (status === QueryStatus.Loading) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [status]);

  if (!operacion) {
    return (
      <></>
    );
  }

  if (status === QueryStatus.Error) {
    return (
      <Alert severity='error'>
        Se produjo un error al cargar la operación.
      </Alert>
    );
  }

  return (
    <SistemaCorporateLendingContent
      operacion={operacion}
    />
  );
}

export default SistemaCorporateLending;